import 'regenerator-runtime/runtime.js'

import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './components/App/app'

import {
  EnvContextProvider,
  AppContextProvider,
  PageStateContextProvider,
  ModalDialogContextProvider,
} from 'client/hooks'

import './dictionary/i18n'

import 'semantic-ui-css/semantic.min.css'
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css'
import 'react-toastify/dist/ReactToastify.css'
import 'rsuite/Slider/styles/index.less'
import './styles/index.scss'

let env = {
  ADMIN_USER_ID: '',
  AWS_BUCKET_URL: '',
  RECAPTCHA_SITE_KEY: '',
  DONATION_PAYMENT_LINK: '',
  FULL_ACCOUNT_PAYMENT_LINK: '',
}

const envElement = document.getElementById('env')

if (envElement) {
  env = JSON.parse(decodeURIComponent(envElement.innerHTML))
}

const Node = () => (
  <BrowserRouter>
    <EnvContextProvider
      adminUserId={env.ADMIN_USER_ID || process.env.ADMIN_USER_ID}
      awsBucketUrl={env.AWS_BUCKET_URL || process.env.AWS_BUCKET_URL}
      recaptchaSiteKey={env.RECAPTCHA_SITE_KEY || process.env.RECAPTCHA_SITE_KEY}
      donationPaymentLink={env.DONATION_PAYMENT_LINK || process.env.DONATION_PAYMENT_LINK}
      fullAccountPaymentLink={
        env.FULL_ACCOUNT_PAYMENT_LINK || process.env.FULL_ACCOUNT_PAYMENT_LINK
      }
    >
      <AppContextProvider>
        <PageStateContextProvider>
          <ModalDialogContextProvider>
            <App />
          </ModalDialogContextProvider>
        </PageStateContextProvider>
      </AppContextProvider>
    </EnvContextProvider>
  </BrowserRouter>
)

const container = document.getElementById('root')

if (process.env.NODE_ENV === 'production') {
  hydrateRoot(container, <Node />)
} else {
  const root = createRoot(container)
  root.render(<Node />)
}
